import { ArrowUpRight } from "lucide-react";
import { T } from "@/constants/testIds";
import { LINKS, CONTRACT } from "@/constants/links";
import CopyContract from "@/components/CopyContract";
import Reveal from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Get ETH on Robinhood Chain",
    body: "Bridge ETH to Robinhood Chain (Chain ID 4663) or withdraw straight from the Robinhood app. Gas is cheap. Hoodies are not.",
  },
  {
    n: "02",
    title: "Open Uniswap",
    body: "Hit the button below. It lands you on Uniswap with Robinhood Chain selected and $DIH already loaded as the output token.",
  },
  {
    n: "03",
    title: "Swap. Put the hood on.",
    body: "Swap ETH for $DIH, confirm in your wallet, and never take it off. That's the whole strategy. There is no step four.",
  },
];

export default function HowToBuy() {
  return (
    <section id="buy" className="relative bg-lime text-ink py-20 md:py-28 border-t-2 border-black" data-testid={T.buy}>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="mb-12 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <div className="kicker mb-4 flex items-center gap-2">
              <span className="live-dot ink" /> How to get hooded
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.9]">
              Three steps.
              <br />
              <span className="text-outline">No step four.</span>
            </h2>
          </div>
          <div className="flex flex-wrap gap-4">
            <a
              href={LINKS.uniswap}
              target="_blank"
              rel="noreferrer"
              data-testid={T.buyUniswap}
              className="btn btn-pink"
            >
              Swap on Uniswap <ArrowUpRight size={16} />
            </a>
            <CopyContract testid={T.buyCopy} className="btn-ink" label="Copy CA" />
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08} className="h-full">
              <div className="h-full rounded-[1.5rem] border-2 border-black bg-[color:var(--paper)] p-7 md:p-8 shadow-[6px_6px_0_#0a0a0a] hover:-translate-y-1 hover:shadow-[9px_9px_0_#0a0a0a] transition-[transform,box-shadow] duration-300 flex flex-col">
                <div className="font-display text-5xl leading-none">{s.n}</div>
                <div className="font-display text-xl md:text-2xl uppercase mt-8 leading-tight">{s.title}</div>
                <p className="mt-3 text-base text-ink/70 leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-8 md:mt-10">
          <div className="rounded-[1.5rem] border-2 border-black bg-ink text-paper p-6 md:p-8 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <div className="kicker text-[color:var(--muted)] mb-2">Contract</div>
              <div className="font-mono text-xs md:text-sm break-all text-lime">{CONTRACT}</div>
            </div>
            <div>
              <div className="kicker text-[color:var(--muted)] mb-2">Network</div>
              <div className="font-mono text-xs md:text-sm">Robinhood Chain · ID 4663</div>
              <div className="font-mono text-xs text-paper/50 mt-1 break-all">rpc.mainnet.chain.robinhood.com</div>
            </div>
            <div>
              <div className="kicker text-[color:var(--muted)] mb-2">Ticker</div>
              <div className="font-mono text-xs md:text-sm">$DIH · 18 decimals</div>
              <div className="font-mono text-xs text-paper/50 mt-1">Hood: permanently on</div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
